<template>
	<OrganismBanner
		title="Start met een gratis proefles Small Group Training"
		subtitle="Train vrijblijvend een keer mee met een van onze Small Group Training lessen en ervaar hoe leuk en motiverend sporten met intensieve begeleiding van een trainer is!"
		:to="{
			url: '/small-group-training/aanmelden-proefles',
			title: 'Meld je aan voor een gratis proefles',
		}"
		button-text="Train gratis mee"
		button-icon="fa-bolt"
	/>
</template>
